const SNAP_THRESHOLD = 3;

const edgesFor = (start, size, isPage = false) => [
  { value: start, kind: "edge", isPage },
  { value: start + size / 2, kind: "center", isPage },
  { value: start + size, kind: "edge", isPage },
];

const closestSnap = (draggedPoints, targets, threshold) => {
  let best = null;
  draggedPoints.forEach((dragged) => {
    targets.forEach((target) => {
      if (dragged.kind !== target.kind) return;
      const dist = Math.abs(dragged.value - target.value);
      if (dist <= threshold && (!best || dist < best.dist || (dist === best.dist && target.isPage))) {
        const kind = target.isPage && target.kind === "center" ? "center" : "edge";
        best = { dist, delta: target.value - dragged.value, position: target.value, kind };
      }
    });
  });
  return best;
};

export const getSnapAdjustment = (
  { top, left, width, height },
  siblingDimensions = {},
  pageDimensions = {},
  threshold = SNAP_THRESHOLD
) => {
  const targetsX = [];
  const targetsY = [];

  Object.values(siblingDimensions).forEach((sibling) => {
    if (!sibling) return;
    targetsX.push(...edgesFor(sibling.left, sibling.width));
    targetsY.push(...edgesFor(sibling.top, sibling.height));
  });

  if (pageDimensions?.width) {
    targetsX.push(...edgesFor(0, pageDimensions.width, true));
  }
  if (pageDimensions?.height) {
    targetsY.push(...edgesFor(0, pageDimensions.height, true));
  }

  const bestX = closestSnap(edgesFor(left, width), targetsX, threshold);
  const bestY = closestSnap(edgesFor(top, height), targetsY, threshold);

  return {
    deltaX: bestX?.delta ?? 0,
    deltaY: bestY?.delta ?? 0,
    verticalGuide: bestX ? bestX.position : null,
    horizontalGuide: bestY ? bestY.position : null,
    verticalGuideKind: bestX ? bestX.kind : null,
    horizontalGuideKind: bestY ? bestY.kind : null,
  };
};
